import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import Splide from '@splidejs/splide';
var defaults = {
  arrows: true,
  padding: '3em',
  pagination: true,
  paginationType: 'numbers'
};
export var carouselBehavior = function carouselBehavior() {
  Alpine.data('carouselBehavior', function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaults,
      arrows = _ref.arrows,
      padding = _ref.padding,
      pagination = _ref.pagination,
      paginationType = _ref.paginationType;
    return {
      carousel: undefined,
      padding: padding,
      pagination: pagination,
      paginationType: paginationType,
      arrows: arrows,
      init: function init() {
        this.initSlider();
      },
      initSlider: function initSlider() {
        if (this.carousel === undefined) {
          var _pagination = this.pagination;
          var _padding = this.padding;
          this.carousel = new Splide(this.$el, {
            pagination: _pagination,
            arrows: arrows,
            perPage: 1,
            arrowPath: 'M30.429 16.2081L17.019 3.91558L20.5545 0.674683L40 18.4998L20.5545 36.3246L17.019 33.0837L30.429 20.7914H0V16.2081H30.429Z',
            gap: '2em',
            padding: _padding,
            omitEnd: true,
            breakpoints: {
              640: {
                padding: '0'
              }
            }
          });
          if (_pagination) {
            var _paginationType = this.paginationType;
            this.carousel.on('pagination:mounted', function (data) {
              // You can add your class to the UL element
              data.list.setAttribute('tabindex', '0');
              data.list.classList.add('splide__pagination--custom', "splide__pagination--".concat(_paginationType));

              // `items` contains all dot items
              data.items.forEach(function (item) {
                item.button.setAttribute('tabindex', '-1');
                item.button.classList.add("splide__pagination__page--".concat(_paginationType));
                if (_paginationType === 'numbers') {
                  item.button.textContent = String(item.page + 1);
                }
              });
            });
          }

          // Add the `inert` attribute to the inactive slides.
          this.carousel.on('inactive', function (slide) {
            slide.slide.setAttribute('inert', '');
          });
          this.carousel.on('active', function (slide) {
            slide.slide.removeAttribute('inert');
          });
          this.carousel.mount();
        }
      }
    };
  });
};